import OkButton from "../../../Button/OKButton/OKButton";
import ReplacementStatusModal from "../ReplacementStatusModal/ReplacementStatusModal";

import moment from "moment";

import "./ReplacementModal.scss";


const ReplacementModal = (
    {
        modalData,
        proceed,
        close,
        delegation,
    }
) => {

    // const { from, to, subject, body } = modalData;
    console.log(modalData);
    return (
        <div className={"replacement-modal"}>
            <div className={"replacement-modal__header"}>Удалить { delegation ? delegation : "замещение"} </div>
            <div className={"replacement-modal__body"}>
                Вы действительно хотите удалить { delegation ? delegation : "замещение"} на
                {" "}
                <span className={"replacement-modal__body__bold"}>
                    { delegation ? modalData.delegate.fullName :   modalData.substitute.fullName}
                </span>
                {" "}
                на период с
                {" "}
                <span className={"replacement-modal__body__bold"}>
                    {moment(modalData.from).format("DD.MM.YYYY")}
                </span>
                {" "}
                {modalData.to ? " по" + " " : ""}

                {" "}
                {
                    modalData.to ?
                        <span className={"replacement-modal__body__bold"}>
                            {moment(modalData.to).format("DD.MM.YYYY")}
                        </span> : ""
                }
                ?
            </div>
            <div className={"replacement-modal__buttons"}>
                <OkButton handler={close} title={"Отмена"} />
                <OkButton handler={proceed} title={"Удалить"} />
            </div>
        </div>
    );
};


export default ReplacementModal;
